import React from "react";

export default function Reel() {
    const fbReel=[{
        title:"fb reel1",
        url:"https://www.facebook.com/reel/2136209923587179"
    },
    {
        title:"fb reel2",
        url:"https://www.facebook.com/reel/1487078012896116"
    },
    {
        title:"fb reel3",
        url:"https://www.facebook.com/reel/1691477821983696"
        }
];



  return (<section className="flex flex-col md:grid  grid-cols-2 lg:flex lg:flex-row justify-evenly items-center ">

{
fbReel.map((e)=>{
 return     <div className=" items-center p-2  ">

   <iframe src= {`https://www.facebook.com/plugins/video.php?href=${encodeURI(e.url)}`}
    width='300'
    height="580"
    style={{ border: "none", overflow: "hidden" }}
    scrolling="no"
    allowFullScreen={true}
    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
title={e.title}
frameBorder="0"
className="rounded-xl"
loading="lazy"
></iframe>

</div>

})
}     
  </section>

    
  );
}